import React from 'react';
import '../../../Styles/interests.css'

const Interest = ({icon, title, description}) => {
    return (
        <div className="o-interest">
            <i className={`fas ${icon} o-icon-fa`}></i>
            <h3 className="o-interest-title">{title}</h3>
            <p>{description}</p>
        </div>
    );
};
export default Interest;